<form
  class="update-record-dialog"
  [formGroup]="serviceForm"
  (ngSubmit)="updateReminder()"
>
  <section class="record-summary" aria-label="Service reminder context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-bell"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">Edit Service Reminder</span>
      <h2>{{ serviceForm.get('vehicle_reference')?.value || 'Select a vehicle' }}</h2>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section__header">
      <h3>Reminder details</h3>
    </div>

    <div class="form-grid">
      <div class="form-field">
        <label for="vehicleRef">Vehicle Reference</label>
        <p-dropdown
          inputId="vehicleRef"
          placeholder="Select a Vehicle"
          formControlName="vehicle_reference"
          optionLabel="vehicle_reference"
          [options]="vehicleList"
          optionValue="vehicle_reference"
          [filter]="true"
          filterBy="vehicle_reference"
          appendTo="body"
          styleClass="w-full"
          (onChange)="onChangeVehicleReference()"
        ></p-dropdown>
      </div>

      <div class="form-field">
        <label for="kmReading">KM Reading</label>
        <input
          id="kmReading"
          pInputText
          formControlName="km_reading"
          class="w-full"
        />
      </div>

      <div class="form-field">
        <label for="serviceDueDate">Service Due Date</label>
        <p-calendar
          inputId="serviceDueDate"
          formControlName="service_due_date"
          dateFormat="yy-mm-dd"
          [inline]="false"
          appendTo="body"
          styleClass="w-full"
        ></p-calendar>
      </div>

      <div class="form-field">
        <label for="serviceDelta">KM Remaining Before Service</label>
        <input
          id="serviceDelta"
          pInputText
          type="number"
          formControlName="service_delta"
          placeholder="e.g. 5000"
          class="w-full"
        />
      </div>
    </div>
  </section>

  <div class="dialog-actions">
    <button
      pButton
      type="submit"
      icon="pi pi-check"
      label="Update Service Reminder"
      class="p-button-primary w-full"
      [loading]="loading"
    ></button>
  </div>
</form>
